var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGagarinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 93,
    viewBox: "0 0 239 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.938 36.7456L153.929 36.7456L153.929 36.7467C153.97 36.7459 154.011 36.7455 154.052 36.7455C157.607 36.7455 160.488 39.6284 160.488 43.1846C160.488 46.2583 158.336 48.8289 155.456 49.4699L155.458 49.4824L152.26 50.4127L155.361 57.3457H151.045L147.002 48.2435L149.728 47.4565L149.729 47.4531L150.729 47.1676L150.799 47.1472L150.8 47.1474L154.69 46.0364L154.689 46.0315C155.984 45.7373 156.95 44.5788 156.95 43.1944C156.95 41.6282 155.713 40.3511 154.163 40.2877L154.163 40.2894H143.9C143.671 40.2894 143.464 40.155 143.37 39.9463L141.938 36.7456Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.716 36.7457H185.193H185.935L197.104 52.4672V36.7457H200.688V56.0868L196.299 57.3457H196.244L185.193 41.7909V57.3457H181.609V37.6369L184.716 36.7457Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.766 36.7457H172.351V57.3457H168.766V36.7457Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3867 36.7457H79.5061L88.6383 57.3457H84.5189L75.3867 36.7457Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.039 36.7457H126.92L117.787 57.3457H121.907L131.039 36.7457Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.2617 36.7457H75.1423L66.0101 57.3457H70.1295L79.2617 36.7457Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.232 50.4119L150.512 55.9953L151.658 58.5703L155.443 57.372L152.232 50.4119Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.08 36.7461H126.961L136.093 57.3461H138.427V56.261H139.732L131.08 36.7461Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.736 57.4082C102.8 57.4082 102.864 57.4076 102.928 57.4065C109.191 57.3797 111.357 56.227 111.357 56.227L111.357 56.2267L111.357 56.2267L111.357 47.6657L107.784 48.6906L107.784 53.4751C106.753 53.6349 105.173 53.7738 102.791 53.7771L102.791 53.7767L102.743 53.7771L102.706 53.7771V53.7772C98.99 53.7772 95.9779 50.7638 95.9779 47.0465C95.9779 43.4478 98.801 40.5087 102.352 40.325L102.352 40.3192C105.165 40.1648 109.19 40.5846 110.528 40.9002V37.3046C109.45 37.0681 106.524 36.6271 102.295 36.7464L102.293 36.7559C96.7956 36.9883 92.4102 41.5205 92.4102 47.0774C92.4102 52.7829 97.0334 57.4082 102.736 57.4082Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3654 57.4082C51.4295 57.4082 51.4935 57.4076 51.5574 57.4065C57.8201 57.3796 59.986 56.227 59.986 56.227L59.9858 56.2266L59.986 56.2267L59.986 47.6656L56.4132 48.6906V53.475C55.3825 53.6349 53.8026 53.7738 51.4198 53.7771L51.4198 53.7767L51.3741 53.7771L51.3347 53.7771V53.7772H51.3346C47.619 53.7772 44.6069 50.7638 44.6069 47.0465C44.6069 43.4478 47.43 40.5087 50.9814 40.325L50.9812 40.3192C53.7943 40.1647 57.8196 40.5846 59.1571 40.9002V37.3046C58.0792 37.0681 55.1533 36.6271 50.9241 36.7463L50.922 36.7559C45.4246 36.9882 41.0391 41.5204 41.0391 47.0774C41.0391 52.7829 45.6623 57.4082 51.3654 57.4082Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.776 19.4564C170.878 45.2579 110.574 70.7331 57.6172 73.9058C48.6537 74.4428 41.6753 73.7724 36.6312 72.1864C31.5835 70.5992 28.567 68.0014 27.3332 64.9843C26.7396 63.5325 26.7718 61.6711 27.3332 59.8276C28.9175 54.6258 32.2307 52.485 36.5035 49.7241L36.6312 49.6415C31.215 51.6787 26.0682 55.9891 24.5023 60.6718C23.7892 62.804 23.9389 65.2089 24.6813 67.0246C26.1086 70.5152 30.0697 73.3988 35.7508 75.1225C41.4394 76.8484 47.3034 77.3388 57.6172 76.7209C82.8159 75.2112 113.171 67.4883 136.57 58.1795C139.388 57.0585 142.224 55.9463 145.094 54.8207C164.68 47.1397 185.85 38.8371 213.625 22.8825L213.302 20.6208C213.268 20.3787 213.097 20.1781 212.863 20.1055L210.776 19.4564Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M218.777 15.2726C218.937 15.2326 219.07 15.3986 218.997 15.5463L217.857 17.8385C217.648 18.2601 217.672 18.7603 217.922 19.1594L219.279 21.3296C219.367 21.4696 219.25 21.6478 219.087 21.6236L216.556 21.2477C216.09 21.1786 215.622 21.3564 215.32 21.7173L213.676 23.6793C213.57 23.8058 213.365 23.7499 213.337 23.5872L212.912 21.0627C212.834 20.5984 212.521 20.2081 212.084 20.032L209.711 19.0744C209.558 19.0126 209.548 18.7999 209.694 18.7236L211.962 17.5393C212.38 17.3214 212.654 16.9023 212.686 16.4325L212.863 13.8788C212.875 13.7141 213.074 13.6385 213.192 13.7541L215.019 15.5466C215.355 15.8762 215.838 16.0076 216.294 15.8934L218.777 15.2726Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGagarinLogo);
export default __webpack_public_path__ + "static/media/Gagarin-logo.a1650d02cb3889bf17512107cc613fd9.svg";
export { ForwardRef as ReactComponent };